const result = [
  {
    id: 0,
    name: "삼색이",
    feature: {
      feat_1: "#맹수 같음",
      feat_2: "#도도시크",
      feat_3: "#경계력 90",
      feat_4: "#눈치 빠름",
      feat_5: "#차가운 도시\n슴숙",
    },
  },
  {
    id: 1,
    name: "우동이",
    feature: {
      feat_1: "#귀차니즘",
      feat_2: "#사랑보다\n우정",
      feat_3: "#혼자 잘 놈",
      feat_4: "#나름\n귀여움",
      feat_5: "#좋아하면\n껌딱지",
    },
  },
  {
    id: 2,
    name: "보리",
    feature: {
      feat_1: "#햇빛사랑",
      feat_2: "#자는 거\n좋아",
      feat_3: "#경계심",
      feat_4: "#독립성\n강함",
      feat_5: "#사랑받는\n막내",
    },
  },
  {
    id: 3,
    name: "랑이",
    feature: {
      feat_1: "#사람좋아",
      feat_2: "#애교쟁이",
      feat_3: "#깨끗함",
      feat_4: "#공주님\n혹은 황제",
      feat_5: "#외향적인듯?\n내향적인?",
    },
  },
  {
    id: 4,
    name: "우치",
    feature: {
      feat_1: "#권력자",
      feat_2: "#인기짱",
      feat_3: "#팜므파탈",
      feat_4: "#노는 거\n최고",
      feat_5: "#우정보단\n사랑?",
    },
  },
  {
    id: 5,
    name: "지붕이",
    feature: {
      feat_1: "#카리스마",
      feat_2: "#이 구역\n짱먹음",
      feat_3: "#독재적",
      feat_4: "#먹는 거\n좋아",
      feat_5: "#밖순이\n집에만 있기\n싫어!",
    },
  },
];

export default result;
